import React, { useEffect } from "react";
import { useThemeContext } from "context/ThemeContext";
import { useAppContext } from "context/AppContext/AppContext";
import { setScenario, reset } from "context/AppContext/actions";

import cn from "classnames";
import ScenarioIntro from "components/ScenarioIntro";
import { StepLearnMore, StepQuestion } from "components/Step";
import styled from "styled-components";
import Navbar from "components/Navbar";

const StyledScenario = styled.div`
  /* max-width: 2160px; */
  margin: 0 auto;
  width: 100%;
  overflow-x: hidden;
  position: relative;
`;

const Scenario = ({ scenarioData }) => {
  const { setCurrentTheme } = useThemeContext();
  const { state, dispatch } = useAppContext();
  const { scenario, currentStep, error } = state;

  // useEffect(() => {
  //   if (currentStep) console.log('Current step ID: ' + currentStep.id );
  // }, [currentStep])

  useEffect(() => {
    dispatch(setScenario(scenarioData));

    return () => {
      dispatch(reset());
    };
  }, [dispatch, scenarioData]);

  useEffect(() => {
    setCurrentTheme(scenarioData.theme);
  }, [scenarioData, setCurrentTheme]);

  return (
    <StyledScenario className={cn("scenario", scenario?.id)}>
      {scenario && (
        <>
          <Navbar />
          {!error && !currentStep && <ScenarioIntro intro={scenario.intro} />}
          {!error && currentStep && currentStep.type === "question" && <StepQuestion key={currentStep.id} />}
          {!error && currentStep && currentStep?.type === "learnmore" && <StepLearnMore key={currentStep.id} />}
          {error && (
            <div className="container margin-v-10" style={{ textAlign: "center" }}>
              {error}
            </div>
          )}
        </>
      )}
    </StyledScenario>
  );
};

export default Scenario;
